import axios from "axios";
import { Apis, BaseUrl } from "../../config";
import { getSession } from "../authActions";

export const refTypesList = () => async (dispatch) => {
  const { token } = getSession();
  dispatch({ type: "refList_req" });
  try {
    const response = await axios.get(`${BaseUrl}${Apis.refdatatypes}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch({ type: "refList_success", payload: response.data });
  } catch (error) {
    dispatch({
      type: "refList_failure",
      payload: error?.response?.data,
    });
  }
};

export const citylist = (selectedCountry) => async (dispatch) => {
  const { token, role_id, user_profile_id } = getSession();
  dispatch({ type: "cityList_req" });

  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.cityList}/${selectedCountry}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          sys_user_id: user_profile_id,
          role_id: role_id,
        },
      }
    );
    dispatch({ type: "cityList_success", payload: response.data });
  } catch (error) {
    dispatch({
      type: "cityList_failure",
      payload: error?.response?.data,
    });
  }
};
export const citylistiso = (selectedCountry) => async (dispatch) => {
  const { token, role_id, user_profile_id } = getSession();
  dispatch({ type: "cityList_req" });

  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.cityListiso}/${selectedCountry}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          sys_user_id: user_profile_id,
          role_id: role_id,
        },
      }
    );
    dispatch({ type: "cityList_success", payload: response.data });
  } catch (error) {
    dispatch({
      type: "cityList_failure",
      payload: error.response.data,
    });
  }
};
export const servicelist = (selectedCity) => async (dispatch) => {
  const { token, role_id, user_profile_id } = getSession();
  dispatch({ type: "serviceList_req" });

  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.svcTyp}/${selectedCity}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          sys_user_id: user_profile_id,
          role_id: role_id,
        },
      }
    );
    dispatch({ type: "serviceList_success", payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({
      type: "cityList_failure",
      payload: error.response.data,
    });
  }
};
